import { render, staticRenderFns } from "./CampaignInfoCell.vue?vue&type=template&id=5f621f4a&scoped=true"
import script from "./CampaignInfoCell.vue?vue&type=script&lang=js"
export * from "./CampaignInfoCell.vue?vue&type=script&lang=js"
import style0 from "./CampaignInfoCell.vue?vue&type=style&index=0&id=5f621f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f621f4a",
  null
  
)

export default component.exports